// this is the event emitted by the payment iframe on complete, required for native payment webview
enum PaymentState {
  PAYMENT_COMPLETE = "PAYMENT_COMPLETE"
}

export default PaymentState
